// For full API documentation, including code examples, visit https://wix.to/94BuAAs
import wixData from 'wix-data';
$w.onReady(function () {
	//TODO: write your page related code here...

});
